export const en = {
    'needs-price': 'Enter a price',
    'price-error-text': 'An unexpected error occurred. Try again later.',
    'price-greater-then-max': 'Price is above the maximum possible value',
    'price-greater-then-max-with-value': 'Price cannot be more than {value}',
    'price-greater-then-min': 'Price cannot be less than or equal to {value}',
    'price-validate-error': 'A validation error occurred. Try again later.',
    'priceOld-greater-then-max': 'The old price is above the maximum possible value',
    'priceOld-greater-then-max-with-value': 'Old price cannot be more than {value}',
    'priceOld-greater-then-min': 'Old price cannot be less than or equal to {value}',
    'priceOld-greater-then-price': 'The price should be less than the old price'
};
